



import MainBanner from '../sections/banner/template_01';







import SpeakerAnnouncement from '../sections/speaker_announcement/template_01';







import Games from '../sections/games/template_02';


import GamesM from '../sections/games/template_02';

import { AiOutlineUp } from "react-icons/ai";


import SECTION_SECTION_DISCOVER_GAMES from
'../dynamic_section/dynamic_1/template_02';





import SECTION_SECTION_SLOT_GAMES from
'../dynamic_section/dynamic_1/template_02';





import SECTION_SECTION_LIVE_CASINO from
'../dynamic_section/dynamic_1/template_01';





import SECTION_1675926682244 from
'../dynamic_section/dynamic_1/template_02';



import RankingList from '../sections/ranking/template_02';


import SECTION_AFFILIATE from '../sections/affiliate/template_01';






import SECTION_SECTION_SPORTS from
'../dynamic_section/dynamic_1/template_01';





import SECTION_FOOTER_BANNER from
'../dynamic_section/dynamic_2/template_01';



import "./style.css";

import FloatingIcon from '../components/FloatingIcon';
import { useEffect, useState } from "react";
import { useMiddletier } from "../common/middletier";
import { useTranslation } from 'react-i18next';


const Main = ()=>{
  
  const [floatingIcon, setFloatingIcon] = useState([])
  const { queries, mutation } = useMiddletier()
  const { t, i18n } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    queries([
      {
        index: 'getFloatingIcons',
        method: 'getFloatingIcons',
        params: [
          { code: 'language', graphqlType: 'String', required: true, value: i18n.resolvedLanguage },
          { code: 'website', graphqlType: 'String', required: false, value: 'MEMBER' },
        ],
        attributes: []
      }
    ])
      .then(({ data }) => {
        setFloatingIcon(data['getFloatingIcons'])
      })
      .catch((error) => {
        console.error(error)
      })
  }, [queries, i18n.resolvedLanguage])
  
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

return (
  <div id="main" class="page ">
  


  
  
  <MainBanner navigation={ false } speed={
    2.5 } pagination={ true } />
  
  
  <SpeakerAnnouncement desktopToggle={ true } mobileToggle={
    true } iconToggle={ true } titleToggle={
    false } />
  

  
  <SECTION_AFFILIATE desktopToggle={ true } mobileToggle={
    true } iconToggle={ true } titleToggle={
    false } />
  
  
  

  
  <GamesM desktopToggle={ false } mobileToggle={
    true } imageToggle={ true } titleToggle={
    false } gameProviderNameToggle={ true } rowMobile={
    2 } rowDesktop={ 2 } position={``} imageSize={
    `1x1` } folderImage={``} titlePosition={'start'}/>
  
  

  
  <Games desktopToggle={ true } mobileToggle={
    false } imageToggle={ true } titleToggle={
    true } gameProviderNameToggle={ true } rowMobile={
    2 } rowDesktop={ 2 } position={``} imageSize={
    `1x1` } folderImage={``} menuPosition={`horizontal`} titleIconToggle={false} titlePosition={'center'}/>
  
  
  
  

  
  < SECTION_SECTION_DISCOVER_GAMES desktopToggle={ true }
    mobileToggle={ true } label={ `Section_HOT_GAMES` } id={ `Section_HOT_GAMES` }
    imageSize={`1x1`} contentPosition={`bottom`}
    actionPosition={`hover`} rowDesktop={ 6 }
    rowMobile={ 3 } numberOfRow={ 1 }
    dataType={`game`} noPadding={ false } filter={`SL`}
    titleToggle={ true } titleIconToggle={ false }
    cardPosition={``} pagination={ false }
    autoplay={ true } navigation={ false }
    dynamicQuery={`HOT` } filterTabToggle={ false }
    folderImage={``} noLink={ false } />
  
  
  
  < SECTION_SECTION_DISCOVER_GAMES desktopToggle={ true }
    mobileToggle={ true } label={ `Section_CASINO_GAMES` } id={ `Section_CASINO_GAMES` }
    imageSize={`1x2`} contentPosition={`bottom`}
    actionPosition={`hover`} rowDesktop={ 5 }
    rowMobile={ 2 } numberOfRow={ 1 }
    dataType={`game`} noPadding={ false } filter={`SL`}
    titleToggle={ true } titleIconToggle={ false }
    cardPosition={``} pagination={ false }
    autoplay={ true } navigation={ false }
    dynamicQuery={`HOT` } filterTabToggle={ false }
    folderImage={``} noLink={ false }/>


< SECTION_SECTION_DISCOVER_GAMES desktopToggle={ true }
    mobileToggle={ true } label={ `Section_partners` } id={ `Section_partners` }
    imageSize={`1x2`} contentPosition={`none`}
    actionPosition={`none`} rowDesktop={ 8 }
    rowMobile={ 3 } numberOfRow={ 1 }
    dataType={`game provider`} noPadding={ true } filter={`SL`}
    titleToggle={ true } titleIconToggle={ false }
    cardPosition={``} pagination={ false }
    autoplay={ true } navigation={ false }
    dynamicQuery={`` } filterTabToggle={ false }
    folderImage={`logo`} noLink={ true }/>

  
  {/* < SECTION_SECTION_SLOT_GAMES desktopToggle={ true }
    mobileToggle={ false } label={ `Section_SLOT_GAMES` } id={ `Section_SLOT_GAMES` }
    imageSize={`1x1`} contentPosition={`none`}
    actionPosition={``} rowDesktop={ 6 }
    rowMobile={ 1 } numberOfRow={ 1 }
    dataType={`game provider`} noPadding={ false } filter={`SL`}
    titleToggle={ true } titleIconToggle={ false }
    cardPosition={``} pagination={ false }
    autoplay={ true } navigation={ false }
    dynamicQuery={`` } filterTabToggle={ false }
    folderImage={``} noLink={ false }/> */}
  
  
  
  

  
  {/* < SECTION_SECTION_LIVE_CASINO desktopToggle={ true }
    mobileToggle={ false } label={ `Section_LIVE_CASINO` } id={ `Section_LIVE_CASINO` }
    imageSize={`1x2`} contentPosition={`none`}
    actionPosition={``} rowDesktop={ 3 }
    rowMobile={ 1 } numberOfRow={ 1 }
    dataType={`game provider`} noPadding={ true } filter={`LC`}
    titleToggle={ true } titleIconToggle={ true }
    cardPosition={``} pagination={ true }
    autoplay={ true } navigation={ true }
    dynamicQuery={`FAV` } filterTabToggle={ false }
    folderImage={``} noLink={ false }/>
  
  
  
  

  
  < SECTION_1675926682244 desktopToggle={ true }
    mobileToggle={ false } label={ `Section_1675926682244 Dynamic Section` } id={ `Section_1675926682244` }
    imageSize={`1x2`} contentPosition={`none`}
    actionPosition={``} rowDesktop={ 5 }
    rowMobile={ 1 } numberOfRow={ 1 }
    dataType={`game provider`} noPadding={ false } filter={`LC`}
    titleToggle={ false } titleIconToggle={ true }
    cardPosition={``} pagination={ false }
    autoplay={ true } navigation={ false }
    dynamicQuery={`UNFAV` } filterTabToggle={ false }
    folderImage={``} noLink={ false }/>
  
  
  
  

  
  <RankingList desktopToggle={ true } mobileToggle={
    true } desktopBannerToggle={ false } mobileBannerToggle={
    false } badgeToggle={ false } userAvatarToggle={
    false } row={ 5 } />
  
  
  
  

  
  < SECTION_SECTION_SPORTS desktopToggle={ true }
    mobileToggle={ false } label={ `Section_SPORTS` } id={ `Section_SPORTS` }
    imageSize={`1x2`} contentPosition={`none`}
    actionPosition={``} rowDesktop={ 3 }
    rowMobile={ 1 } numberOfRow={ 1 }
    dataType={`game provider`} noPadding={ false } filter={`SB`}
    titleToggle={ true } titleIconToggle={ true }
    cardPosition={``} pagination={ true }
    autoplay={ true } navigation={ true }
    dynamicQuery={`new` } filterTabToggle={ false }
    folderImage={``} noLink={ false }/>
  
  
  
   */}

  
  < SECTION_FOOTER_BANNER desktopToggle={ true }
    mobileToggle={ false } label={ `Section_EXCELLENT_SERVICE` } id={ `Section_EXCELLENT_SERVICE` } supportLanguage={
    true } titleToggle={ true } titleIconToggle={
    false } linkTo={ `` } addContainer={ true } numberOfImage={1}  titlePosition={'center'}/>
  
  < SECTION_FOOTER_BANNER desktopToggle={ false }
    mobileToggle={ true } label={ `Section_EXCELLENT_SERVICE` } id={ `Section_EXCELLENT_SERVICE_m` } supportLanguage={
    true } titleToggle={ true } titleIconToggle={
    false } linkTo={ `` } addContainer={ true } numberOfImage={2} titlePosition={'center'}/>
  

  
  {floatingIcon.length > 0 && (floatingIcon?.map(function (item, index) {
    return (
      <FloatingIcon position={item?._floating_icon?.position} enableClose={item?._floating_icon?.enable_close} enableMove={item?._floating_icon?.enable_move} desktopImageUrl={item?.desktop_image_url} mobileImageUrl={item?.mobile_image_url} url={item?._floating_icon?.url} />)
  }))}

<button onClick={scrollToTop} className="scrollToTopButton" >
            <AiOutlineUp />
          </button>

</div>
)
}

export default Main;